import { MenuItem, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const EnumField = ({
  name,
  schema,
  value,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
}) => {
  const labelText = schema.title || name;

  const handleBlur = useCallback(
    (e) => {
      onBlur(name, e.target.value);
    },
    [name, onBlur]
  );

  return (
    <TextField
      select
      fullWidth
      id={`field-${name}`}
      name={name}
      label={labelText}
      value={value || ''}
      required={required}
      InputLabelProps={{ shrink: true }}
      onChange={(e) => onChange(name, e.target.value)}
      onBlur={handleBlur}
      error={touched && !!error}
      helperText={(touched && error) || schema.description || ''}
      aria-invalid={touched && !!error}
      aria-describedby={error ? `${name}-error` : undefined}
    >
      {schema.enum.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};

EnumField.propTypes = {
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    enum: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ).isRequired,
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
};

export default React.memo(EnumField);
